import React from 'react';
import { SideBarTitlePanel } from './SideBarTitlePanel';
import { TagsComponent } from './TagsComponent';
import TransactionsActionCreator from '../../../actions/TransactionsActionCreator';
import AnalyticsActionCreator from '../../../actions/AnalyticsActionCreator';
import config from '../../../config';
import _ from 'lodash';

const styles = {
  sidebar: {
    width: 400,
    height: '100%',
  },

  sideBarNoContent: {
    width: 400,
    textAlign: 'center',
    backgroundColor: 'white',
  },
};

class SidebarContent extends React.Component {
  constructor(props) {
    super(props);
    this.newTagInput = this.newTagInput.bind(this);
    this.doneTagging = this.doneTagging.bind(this);
    this.editTagInputFn = this.editTagInputFn.bind(this);
    this.assignTag = this.assignTag.bind(this);
    this.addNewTag = this.addNewTag.bind(this);
    this.cancelTagging = this.cancelTagging.bind(this);
    this.doneTagging = this.doneTagging.bind(this);
    this.editTagging = this.editTagging.bind(this);
    this.handleAddTagButton = this.handleAddTagButton.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.state = {
      tabKey: -1,
      flagForAddTag: false,
      disableEdit: true,
      disableDone: false,
      flagForEditTag: false,
      newTag: {},
      updateTag: {},
      newTagValue: '',
      editTagInput: '',
      editTagKey: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ flagForEditTag: nextProps.flagForEditTag });
  }

  handleChangeOfTag = (e) => {
    //   e.target.value.length === 0 ? this.setState({ disableDone: true }) : this.setState({ disableDone: false });
    //   // this.setState({ updateTag: updateTag });
    this.setState({ newTagValue: '' });
  };

  addNewTag(e) {
    let newTag;
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description:
          config.analytics.analytics_action_tag_editor_assigned_new_tag,
        event: 'click',
      }
    );
    // if(e.target.value.charAt(0) !== " ") {
    // 	newTag = { 'value': e.target.value };
    // 	e.target.value.length === 0 ? this.setState({ disableDone: true }) : this.setState({ disableDone: false });
    // 	this.setState({ newTag: newTag, newTagValue:e.target.value });
    // } else {
    // 	if (e.target.value.length === 1) {
    // 		newTag = { 'value': e.target.value.trim() };
    // 		this.setState({newTag : newTag, newTagValue:''});
    // 	} else {
    // 		newTag = {'value': _.trimStart(e.target.value),};
    // 		this.setState({newTag : newTag, newTagValue:_.trimStart(e.target.value)});
    // 	}
    // }
    newTag = { value: e.target.value };
    this.setState({ newTag, newTagValue: _.trimStart(e.target.value) }, () => {
      let newTagChanged = this.state.newTagValue;
      if (this.state.newTagValue.length > 1) {
        if (
          this.state.newTagValue.charAt(this.state.newTagValue.length - 1) ===
            ' ' &&
          this.state.newTagValue.charAt(this.state.newTagValue.length - 2) ===
            ' '
        ) {
          newTagChanged = _.trim(this.state.newTagValue);
          newTagChanged += ' ';
        }
      }
      this.state.newTagValue.length === 0
        ? this.setState({ disableDone: true, newTagValue: newTagChanged })
        : this.setState({ disableDone: false, newTagValue: newTagChanged });
    });
  }

  cancelTagging() {
    this.setState({
      flagForAddTag: false,
      flagForEditTag: false,
      newTagValue: '',
    });
    this.props.flagForEditTagFunc(false);
  }

  doneTagging() {
    if (this.state.flagForAddTag) {
      TransactionsActionCreator.addNewTag(this.state.newTagValue);
    }
    if (this.state.editTagInput) {
      if (this.props.flagForEditTag) {
        TransactionsActionCreator.editExistingTag(
          this.state.editTagKey,
          this.state.editTagInput
        );
      }
    }
    this.setState({
      flagForAddTag: false,
      flagForEditTag: false,
      newTagValue: '',
    });
    this.props.flagForEditTagFunc(false);
  }

  editTagging() {
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description:
          config.analytics.analytics_action_tag_editor_edit_tag_selected,
        event: 'click',
      }
    );
    this.setState({ flagForEditTag: true, disableDone: false });
    this.props.flagForEditTagFunc(true);
  }

  handleAddTagButton() {
    this.setState({ flagForAddTag: true, disableDone: true });
  }

  handleSelect(e) {
    e === 2
      ? this.setState({ disableEdit: false })
      : this.setState({ disableEdit: true });
    if (e === 1) {
      this.setState({ flagForAddTag: false, flagForEditTag: false });
      this.props.flagForEditTagFunc(false);
    }
    this.setState({ tabKey: e });
  }

  newTagInput(refValue) {
    this.setState({ newTagValue: refValue });
  }

  editTagInputFn(key, refValue) {
    this.setState({ editTagInput: refValue, editTagKey: key });
  }

  assignTag() {
    this.props.assignTag(this.props.untaggedObj);
  }

  render() {
    const style = styles.sidebar;
    return (
      <SideBarTitlePanel
        title="Menu"
        disableEdit={this.state.disableEdit}
        disableDone={this.state.disableDone}
        noTagSelection={this.props.noTagSelection}
        closeButton={this.props.closeButton}
        flagForAddTag={this.state.flagForAddTag}
        flagForEditTag={this.props.flagForEditTag}
        style={style}
        editTagging={this.editTagging}
        cancelTagging={this.cancelTagging}
        doneTagging={this.doneTagging}
        content={this.props.content}
        rememberThisIconClickOpen={this.props.rememberThisIconClickOpen}
      >
        <div
          className={`sidebar-content ${
            this.props.flagForEditTag || this.state.flagForAddTag ? 'edit' : ''
          }`}
        >
          {this.props.noTagSelection && (
            <div className="tag-tips">
              <h5>Choose your transactions</h5>
              <p>
                Start by choosing the transaction(s) you want to tag, selecting
                one type only (like Groceries or Fuel).
              </p>
            </div>
          )}
          <TagsComponent
            categories={this.props.categoryTags}
            tags={this.props.customTags}
            handleKeyPress={this.addNewTag}
            toggleCheckBox={this.props.toggleCheckBox}
            handleChangeOfTag={this.handleChangeOfTag}
            handleAddTagButton={this.handleAddTagButton}
            flagForAddTag={this.state.flagForAddTag}
            deleteTag={this.props.deleteTag}
            assignTag={this.props.assignTag}
            handleSelect={this.handleSelect}
            flagForEditTag={this.props.flagForEditTag}
            content={this.props.content}
            onTagInfoClick={this.props.onTagInfoClick}
            onRemeberThisInfoClick={this.props.onRemeberThisInfoClick}
            transactionTagData={this.props.transactionTagData}
            unTagSelected={this.props.unTagSelected}
            noTagSelection={this.props.noTagSelection}
            nextAccountDetails={this.props.nextAccountDetails}
            newTagInput={this.newTagInput}
            editTagInput={this.editTagInputFn}
            cssActiveClassForSelectedTags={
              this.props.cssActiveClassForSelectedTags
            }
            newTagValue={this.state.newTagValue}
            rememberThisIconClickOpen={this.props.rememberThisIconClickOpen}
          />
        </div>
        {!this.state.flagForEditTag && !this.state.flagForAddTag && (
          <div className="sidebar-footer">
            <a className="action-bttn" onClick={this.assignTag}>
              Untag Selected
            </a>
          </div>
        )}
      </SideBarTitlePanel>
    );
  }
}

export { SidebarContent };
